import { alpha } from '@mui/material/styles';

import { MARK_COLOR } from './PreviewPagePane.constants';
import { toPercent } from './PreviewPagePane.utils';

const MARK_FRAME_OFFSET = '-4px';

const MARK_FILL_OPACITY = 0.2;

export const previewPaneStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: 0,
};

// The page fills the pane's width, up to a whole Letter page in view; the marks are placed over it
// as fractions of the page.
export const pageFrameStyles = {
  position: 'relative',
  width: '100%',
  maxWidth: '56vh',
  boxShadow: ({ palette }) => palette.shadow.s,
  '& canvas': { display: 'block' },
};

export const getPageMarkStyles = ({ left, top, width, height }) => ({
  position: 'absolute',
  left: toPercent(left),
  top: toPercent(top),
  width: toPercent(width),
  height: toPercent(height),
  pointerEvents: 'none',
});

// A global rule turns `outline` off, so the frame is a bordered box just outside the part, filled
// like a highlighter.
export const pageMarkFrameStyles = {
  position: 'absolute',
  inset: MARK_FRAME_OFFSET,
  border: `2px solid ${MARK_COLOR.FRAME}`,
  borderRadius: ({ shape }) => shape.radius.s,
  backgroundColor: alpha(MARK_COLOR.FILL, MARK_FILL_OPACITY),
  mixBlendMode: 'multiply',
};

// The number sits in the gutter left of the page, level with the part, so it never covers text.
export const getPageMarkBadgeStyles = ({ badgeTop }) => ({
  position: 'absolute',
  top: `${badgeTop}px`,
  right: 'calc(100% + 6px)',
  display: 'flex',
  pointerEvents: 'none',
});
